import { Component, ChangeDetectionStrategy, input, viewChild, ElementRef, computed, signal, linkedSignal, inject } from "@angular/core";
import { AnchorUISref, StateService, UISref } from "@uirouter/angular";
import { IMenu } from "../../types/menu";
import UIkit from "uikit";

@Component({
    selector: 'op-filter-menu',
    templateUrl: "./opFilterMenu.component.html",
    styleUrl: './opFilterMenu.style.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
      UISref,
      AnchorUISref
    ]
})
export class OpFilterMenuComponent {

  private readonly $state = inject(StateService);
  public readonly menu = input.required({ transform: (value: IMenu[]) => this._menuTreeToList(value, '/') });
  public readonly dropElement = viewChild<ElementRef<HTMLElement>>("dropdown");
  public readonly drop = computed(() => UIkit.dropdown(this.dropElement().nativeElement, { mode: "click", pos: "bottom-left", offset: 0 }));
  public readonly suggestions = signal<{ id: string; path: string, link: string, uiParams: any }[]>([]);
  public readonly highlight = linkedSignal<number>(() => this.suggestions().length - this.suggestions().length);

  public previousItem(e: Event) {
    e.preventDefault();
    this.highlight.update((current) => current != 0 ? current - 1 : this.suggestions().length - 1);
  }

  public nextItem(e: Event) {
    e.preventDefault();
    this.highlight.update((current) => current == (this.suggestions().length-1) ? 0 : current + 1);
  }

  public input(e: Event) {
    const query = (e.target as HTMLInputElement).value.toLowerCase();
    if (!query || query.length < 2) return this.suggestions.set([]);
    const items = this.menu().filter(item => item.path.toLowerCase().includes(query));
    this.suggestions.set(items);
    this.drop().show();
  }

  public select(e: Event) {
    e.preventDefault();
    const index = this.highlight();
    const suggestions = this.suggestions();
    if (!suggestions?.length || suggestions.length <= index) return;
    const item = suggestions[index];
    if (!item) return;
    this.$state.go(item.link, item.uiParams);
    this.drop().hide(false);
  }

  private _menuTreeToList(items: IMenu[], parentPath: string): { id: string; path: string, link: string, uiParams: any }[] {
    const list = []
    items.forEach(item => {
      if (item.submenu == undefined) {
        list.push({
          id: item.id,
          link: item.stateName || item.link,
          path: this._rmHtmlTags(`${parentPath} ${item.title}`),
          uiParams: item.uiParams ? item.uiParams : ''
        });
      }
      else if ((item.submenu) && item.submenu.length > 0) {
        list.push(...this._menuTreeToList(item.submenu, `${parentPath} ${item.title} /`));
      }
    });
    return list;
  }

  private _rmHtmlTags(str) {
    return str.replace(/<[^>]*>([^<]*)<\/[^>]+>/, '');
  }
}
